'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FrontendUserProvider = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _LoadUserException = require('./Exception/LoadUserException');

var _AbstractUserProvider2 = require('./AbstractUserProvider');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

let FrontendUserProvider = exports.FrontendUserProvider = function (_AbstractUserProvider) {
  _inherits(FrontendUserProvider, _AbstractUserProvider);

  /**
   * @param {String} retrieveUserResource
   * @param {Object} deepResourceService
   */
  function FrontendUserProvider(retrieveUserResource, deepResourceService) {
    _classCallCheck(this, FrontendUserProvider);

    var _this = _possibleConstructorReturn(this, (FrontendUserProvider.__proto__ || Object.getPrototypeOf(FrontendUserProvider)).call(this));

    _this._retrieveUserResource = retrieveUserResource;
    _this._deepResource = deepResourceService;
    return _this;
  }

  /**
   * @param {String} id
   * @param {Function} callback
   */


  _createClass(FrontendUserProvider, [{
    key: 'loadUserByIdentityId',
    value: function loadUserByIdentityId(id, callback) {
      if (!this._retrieveUserResource) {
        callback(null, null);
        return;
      }

      let retrieveUserResource = this._deepResource.get(this._retrieveUserResource);

      // authScope(null) forces deep-resource to use cognito default credentials
      retrieveUserResource.request({ Id: id }).authScope(null).retry(3).disableCache().send(response => {
        if (response.error) {
          callback(new _LoadUserException.LoadUserException(id, response.error), null);
          return;
        }

        return callback(null, response.data);
      });
    }
  }]);

  return FrontendUserProvider;
}(_AbstractUserProvider2.AbstractUserProvider);


//////////////////
// WEBPACK FOOTER
// ../~/deep-security/lib.compiled/FrontendUserProvider.js
// module id = 445
// module chunks = 0